module.exports = __webpack_public_path__ + "img/plan1.da5c973.png";